import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import {NgxWebstorageModule} from 'ngx-webstorage';
import { ChartsModule,ThemeService } from 'ng2-charts';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxSpinnerModule } from 'ngx-spinner';


import { ReportRoutingModule } from './report-routing.module';
import { VendorActivityService } from './services';
import { VendorActivityComponent,VendorInvoicesComponent } from './components/index';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { CalendarModule } from 'primeng/calendar';
import { SliderModule } from 'primeng/slider';
import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressBarModule } from 'primeng/progressbar';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { FileUploadModule } from 'primeng/fileupload';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MessagesModule } from 'primeng/messages';
import { PanelModule } from 'primeng/panel';
import { SlideMenuModule } from 'primeng/slidemenu';
import { SplitterModule } from 'primeng/splitter';
import { TabViewModule } from 'primeng/tabview';
import { TieredMenuModule } from 'primeng/tieredmenu';
import {TabMenuModule} from 'primeng/tabmenu';
import {BadgeModule} from 'primeng/badge';
import { FiltersModule } from '../filters/filters.module';
import { UserActivityLogComponent } from './components/user-activity-log/user-activity-log.component';
import { EmailDeliveryReportComponent } from './components/email-delivery-report/email-delivery-report.component';
import { ErrorLogComponent } from './components/error-log/error-log.component';
import { ErrorLogViewModalComponent } from './components/error-log/error-log-view-modal/error-log-view-modal.component';
import { EmailReportAnonymousUsersComponent } from './components/email-report-anonymous-users/email-report-anonymous-users.component';


@NgModule({
  declarations: [
    VendorActivityComponent,
    VendorInvoicesComponent,
    UserActivityLogComponent,
    EmailDeliveryReportComponent,
    ErrorLogComponent,
    ErrorLogViewModalComponent,
    EmailReportAnonymousUsersComponent,

  ],
  imports: [
    HttpClientModule,
    CommonModule,
    ReportRoutingModule,
    NgxSpinnerModule,
    ChartsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    ChartsModule,
    TableModule,
    CalendarModule,
		SliderModule,
		DialogModule,
		MultiSelectModule,
		ContextMenuModule,
		DropdownModule,
		ButtonModule,
		ToastModule,
    InputTextModule,
    ProgressBarModule,
    MenuModule,
    MenubarModule,
    CardModule,
    PanelModule,
    TabViewModule,
    InputSwitchModule,
    CheckboxModule,
    MessagesModule,
    FileUploadModule,
    ConfirmPopupModule,  
    SplitterModule, 
    InputNumberModule,
    TieredMenuModule,  
    SlideMenuModule, 
    AccordionModule,
    AvatarModule,
    AvatarGroupModule,
    AutoCompleteModule,
    TabMenuModule,
    BadgeModule,
    NgxWebstorageModule.forRoot(),
    FiltersModule,
  ],
  providers: [
    VendorActivityService,
  ],
})
export class ReportModule { }
